import * as services from './integrationAccounts.queries';

export default services;
